import PageHeader from '../layout/PageHeader.jsx';
import useMsiEffectTitle from '../../hooks/useMsiEffectTitle';

/**
 * De kop boven de losse antwoorden op één vraag.
 *
 * Bij een vraag uit de meetstandaard staat de naam van het gekoppelde effect
 * vóór de vraagtekst: die vragen hebben allemaal dezelfde tekst ("In welke mate
 * ben je het eens met de volgende stellingen?"), dus zonder de effectnaam is
 * niet te zien waar de antwoorden over gaan.
 *
 * @param {object} props
 * @param {object} [props.field] - Het QuestionnaireFields-doc van deze vraag.
 * @param {string} [props.subHeading] - Bijvoorbeeld de naam van de deelnemer.
 */
const ResearchResponsesPageHeader = ({ field, subHeading }) => {
    const effectTitle = useMsiEffectTitle(field?.EffectId);
    const question = String(field?.Question || '').trim();

    return (
        <PageHeader
            heading="Responses"
            subHeading={subHeading}
            description={[effectTitle, question].filter(Boolean).join('  ·  ')}
            AI={false}
        />
    );
};

export default ResearchResponsesPageHeader;
